import { lazy } from "react";

export const CoursesPage = lazy(() => import("./coursesPage"));
